import { DataTable, Paginator, SkeletonLoader, FilterBar } from 'components';

import { humanReadable } from 'utils';

import columns from './columns';
import { ListSixInfoDialog } from './components';
import { ListSixUiProps, ListSixTicket } from './ListSix.types';

function MoreDetailsBodyTemplate(handleListSixInfoDialogShow: any) {
  return function (row: ListSixTicket) {
    return (
      <div
        className="az-tickets__listFive-details"
        role="presentation"
        onClick={handleListSixInfoDialogShow(row.id)}
      >
        Details
      </div>
    );
  };
}

export default function ListSixUi({
  isLoading,
  isListSixInfoVisible,
  totalRecords,
  filter,
  options,
  data: { selectedId, list },
  handlers,
}: ListSixUiProps) {
  return (
    <div className="az-tickets">
      <FilterBar
        loading={isLoading}
        onReset={handlers.handlerClearFilter}
        search={{
          inputs: [
            {
              name: 'azadeaId',
              placeholder: 'Azadea ID',
              value: filter.azadeaId || '',
            },
          ],
          onChange: handlers.handleSearchChange,
          onSubmit: handlers.handleSubmitSearch,
          width: 4,
        }}
        filters={[
          {
            kind: 'dropdown',
            name: 'endorsementStatus',
            label: 'Endorsement status',
            placeholder: 'All endorsement statuses',
            value: filter.endorsementStatus || '',
            options: options.endorsementStatuses,
            onChange: handlers.handlerEndorsementStatuses,
          },
          {
            kind: 'dropdown',
            name: 'azadeaStatus',
            label: 'Azadea status',
            placeholder: 'All Azadea statuses',
            value: filter.azadeaStatus || '',
            options: options.azadeaStatuses,
            onChange: handlers.handleAzadeaStatusChange,
          },
        ]}
      />

      {isLoading ? (
        <SkeletonLoader height="10rem" />
      ) : (
        <DataTable
          sortMode="multiple"
          totalRecords={totalRecords}
          value={list}
          columns={columns.map((column) => {
            if (
              column.field === 'created' ||
              column.field === 'updated' ||
              column.field === 'sentdate' ||
              column.field === 'invoicedate'
            ) {
              return {
                ...column,
                body: (row: any) =>
                  !row[column.field] ? 'N/A' : humanReadable(row[column.field]),
              };
            }

            if (column.field === 'details_link') {
              return {
                ...column,
                body: MoreDetailsBodyTemplate(
                  handlers.handleListSixInfoDialogShow
                ),
              };
            }

            return {
              ...column,
              body: (row: any) =>
                !row[column.field] ? 'N/A' : row[column.field],
            };
          })}
        />
      )}

      {list?.length > 0 &&
        (isLoading ? (
          <SkeletonLoader height="3rem" width="60rem" />
        ) : (
          <Paginator
            first={filter.first}
            rows={filter.rows}
            totalRecords={totalRecords}
            rowsPerPageOptions={[10, 50, 100]}
            onPageChange={handlers.handlePageChange}
          />
        ))}

      {isListSixInfoVisible && (
        <ListSixInfoDialog
          id={selectedId}
          onClose={handlers.handleListSixInfoDialogClose}
        />
      )}
    </div>
  );
}
